import modalVideoUrl from '../../components/components/modal-video.html';
import addEditShiftTemplate from '../AddEditShiftTemplate';
import { YOUTUBE_VIDEO_LABOR_COST } from '../../constants';
import config from '../../config';

class SettingsWithContextController {
  constructor(
    Authentication,
    PersonaCollection,
    TabsControl,
    AccountService,
    LaborCostSettings,
    GoogleCalendarUtils,
    LeaveService,
    Utils,
    Socket,
    $uibModal,
    $sce,
    $rootScope,
    $scope
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      TabsControl,
      AccountService,
      LaborCostSettings,
      GoogleCalendarUtils,
      LeaveService,
      Utils,
      Socket,
      $uibModal,
      $sce,
      $rootScope,
      $scope,
    });
  }

  $onInit() {
    this.init();

    this.$rootScope.$on('sdk:userSettings:save', (e, data) => {
      this.Authentication.user.settings = { ...this.Authentication.user.settings, ...data };
    });

    this.$rootScope.$on('sdk:userOrgSettings:save', (e, data) => {
      this.Authentication.user.orgSettings = { ...this.Authentication.user.orgSettings, ...data };
    });

    this.$scope.$on('$destroy', () => {
      this.tabsControl.destroy();
    });
  }

  async init() {
    // @TODO: gettext for labels is missing
    this.tabs = [
      { value: 'preferences', label: 'PREFERENCES', show: () => true },
      { value: 'notifications', label: 'NOTIFICATIONS', show: () => true },
      {
        value: 'companySettings',
        label: 'COMPANY SETTINGS',
        show: () => this.Authentication.user.isManager,
      },
      { value: 'schedule', label: 'SCHEDULE', show: () => this.Authentication.user.isManager },
      { value: 'timeClock', label: 'TIME CLOCK', show: () => this.Authentication.user.isManager },
    ];

    if (
      this.Authentication.user.isAdmin ||
      (this.Authentication.user.isManager && this.Authentication.user.wouldHaveAccessToLaborCost)
    ) {
      this.tabs.push({
        value: 'laborCost',
        label: 'LABOR COST',
        show: () =>
          this.Authentication.user.isManager && this.Authentication.user.wouldHaveAccessToLaborCost,
      });
    }

    this.tabs.push({
      value: 'timeOff',
      label: 'TIME OFF',
      show: () => this.Authentication.user.isManager,
    });

    this.tabs.push({
      value: 'integrations',
      label: 'INTEGRATIONS',
      show: () => this.Authentication.user.isAdmin,
    });

    if (config.SCHEDULE_INTERVALS_IN_SETTINGS_ENABLED) {
      this.tabs.push({
        value: 'timeBlocks',
        label: 'SCHEDULE INTERVALS',
        show: () =>
          this.Authentication.user.isManager &&
          'shiftTemplates' in this.Authentication.user.orgSettings,
      });
    }

    this.tabsControl = new this.TabsControl(this.tabs, 'preferences');

    if (
      this.Authentication.user.org.isPremium &&
      this.Authentication.user.isManager &&
      this.Authentication.user.wouldHaveAccessToLaborCost
    ) {
      this.laborCostDataLoaded = false;
      await this.LaborCostSettings.loadData();
      this.laborCostDataLoaded = true;
    }
  }

  changeTab = (tab) => {
    this.tabsControl.changeTab(tab);
  };

  saveLaborCostSettings = (settings) => this.LaborCostSettings.save(settings);

  openPremiumGuardModal = (premiumFeatureName, stateAfter, premiumFeature) =>
    this.AccountService.openPremiumGuardModal(premiumFeatureName, stateAfter, premiumFeature);

  openPricingModal = () => {
    this.AccountService.openPricingModal();
  };

  openLaborCostVideoModal() {
    const ctrl = this;
    this.$uibModal
      .open({
        templateUrl: modalVideoUrl,
        windowClass: 'sling-tour-modal sling-animate',
        size: '1020',
        controller() {
          this.videoSrc = ctrl.$sce.trustAsResourceUrl(`${YOUTUBE_VIDEO_LABOR_COST}?autoplay=1`);
        },
        controllerAs: 'ctrl',
      })
      .result.ignoreCancel();
  }

  addEditDayPart(dayPart = {}) {
    return this.$uibModal.open({
      size: '620',
      controller: function addEditDayPartCtrl() {
        this.dayPart = dayPart;
      },
      controllerAs: 'ctrl',
      template:
        '<edit-day-part dismiss="$dismiss()" day-part="ctrl.dayPart" on-submit="$close(dayPart)"></edit-day-part>',
    }).result;
  }

  addEditTimeBlock(timeBlock = {}) {
    if (!Object.keys(timeBlock).length) {
      // We want to create new time block
      const { start, end } = this.Utils.getDefaultStartEnd(
        '2021-01-01',
        undefined,
        this.Authentication.user.orgSettings
      );
      const newTimeBlock = {
        dtstart: start,
        dtend: end,
        locations: [],
      };
      return addEditShiftTemplate(this.$uibModal, newTimeBlock);
    }

    return addEditShiftTemplate(this.$uibModal, timeBlock);
  }
}

export default {
  template: `
    <r-settings-with-context
      user="ctrl.Authentication.user"
      save-client-flags="ctrl.Authentication.saveClientFlags(flags)"
      client-flags="ctrl.Authentication.user.settings.clientFlags"
      persona-collection="ctrl.PersonaCollection"
      tabs="ctrl.tabs"
      active-tab="ctrl.tabsControl.activeTab"
      change-tab="ctrl.changeTab(tab)"
      open-premium-guard-modal="ctrl.openPremiumGuardModal(premiumFeatureName, stateAfter, premiumFeature)"
      labor-cost-settings="ctrl.LaborCostSettings.savedSettings"
      save-labor-cost-settings="ctrl.saveLaborCostSettings(settings)"
      google-calendar-utils="ctrl.GoogleCalendarUtils"
      time-off-types="ctrl.LeaveService.timeOffTypes"
      labor-cost-data-loaded="ctrl.laborCostDataLoaded"
      open-pricing-modal="ctrl.openPricingModal()"
      open-labor-cost-video-modal="ctrl.openLaborCostVideoModal()"
      add-edit-day-part="ctrl.addEditDayPart(dayPart)"
      add-edit-time-block="ctrl.addEditTimeBlock(timeBlock)"
      is-whitelisted="ctrl.Authentication.isWhitelisted"
      set-websocket-callback="ctrl.Socket.setCustomCallback(cb)"
      integrations="ctrl.integrations"
      >
    </r-settings-with-context>
    `,
  controller: SettingsWithContextController,
  controllerAs: 'ctrl',
  bindings: {
    integrations: '<',
  },
};
